import clientsEdit from '@/views/clients/edit'
import clientsList from '@/views/clients/list'

export default [
  {
    path: '/clientes',
    name: 'clientsList',
    component: clientsList,
    meta: {
      layout: 'sidebar',
      type: 'list',
      base: 'clients',
      heading: 'menu.clients',
      auth: true,
      roles: [
        {
          create:  ['super-admin','admin'],
          edit: ['super-admin','admin'],
          remove: ['super-admin','admin']
        }
      ]
    }
  },
  {
    path: '/clientes/novo',
    name: 'clientsCreate',
    component: clientsEdit,
    meta: {
      layout: 'sidebar',
      base: 'clients',
      heading: 'menu.clients',
      auth: true,
      roles: ['super-admin','admin']
    }
  },
  {
    path: '/clientes/:id/editar',
    name: 'clientsUpdate',
    component: clientsEdit,
    meta: {
      layout: 'sidebar',
      base: 'clients',
      heading: 'menu.clients',
      auth: true,
      roles: ['super-admin','admin']
    }
  }
]
